<form [formGroup]="form" class="align-form">
    <div class="field">
        <mat-form-field>
            <mat-label>{{fieldDetails?.name}}</mat-label>
            <input matInput formControlName="{{fieldDetails?.id}}">
            <ng-container *ngIf="userSubmit && formValues[fieldDetails?.id].errors">
                <mat-error *ngIf="formValues[fieldDetails?.id].errors?.['required']">
                    <em class="fas fa-exclamation-circle mr-2"></em>{{fieldDetails?.name}} is required
                </mat-error>
            </ng-container>
        </mat-form-field>
    </div>
</form>